import { z } from "zod";
import type { ESTIMATION_TYPE } from "~/models/DealConstruction";

export type DealEstimationOcrRequestStatus =
	| "processing"
	| "succeeded"
	| "failed";

export type DealEstimationOcrRequestItem = {
	companyChargePer: number | null;
	estimationType: typeof ESTIMATION_TYPE.NONE;
	note: string | null;
	otherName: string;
	ownerChargePer: number | null;
	point: string | null;
	renteeChargePer: number | null;
	seq: number;
	unit: number | null;
	unitAmount: number | null;
	unitName: string | null;
};

export type DealEstimationOcrRequest = {
	dealId: number;
	id: number;
	items: DealEstimationOcrRequestItem[] | null;
	message: string | null;
	reflectedAt: string | null;
	status: DealEstimationOcrRequestStatus;
};

export type DealEstimationOcrRequestCreated = Pick<
	DealEstimationOcrRequest,
	"dealId" | "id"
> & { status: "processing" };

const DEAL_ESTIMATION_OCR_FILE_MIME_TYPE = "application/pdf";
export const DEAL_ESTIMATION_OCR_FILE_ACCEPT = ".pdf";
const BYTES_PER_MEGABYTE = 1_024 * 1_024;
const DEAL_ESTIMATION_OCR_MAX_FILE_SIZE_MB = 20;
export const DEAL_ESTIMATION_OCR_MAX_FILE_SIZE_BYTES =
	DEAL_ESTIMATION_OCR_MAX_FILE_SIZE_MB * BYTES_PER_MEGABYTE;

export const dealEstimationOcrFileSchema = z
	.file()
	.mime(
		[DEAL_ESTIMATION_OCR_FILE_MIME_TYPE],
		"PDFファイルのみアップロードできます。"
	)
	.max(
		DEAL_ESTIMATION_OCR_MAX_FILE_SIZE_BYTES,
		`ファイルサイズは${DEAL_ESTIMATION_OCR_MAX_FILE_SIZE_MB}MB以下にしてください。`
	);
